// FLAGS: none
// Derives the API base URL from the current host plus REACT_APP_API_SUBDOMAIN, and builds the
// external-login, my-sessions and booking URLs from it.
import { env } from "@src/env";
import { t } from "i18next";
import { toExternalHref } from "@src/utils/routerPaths";
import { apiPaths } from "./constants";

export const getApiBaseUrl = (addApi = true) => {
  let hostUrl = window.location.host;
  const urlParts = new URL(`https://${hostUrl}`).hostname.split(".");

  if (urlParts.length > 1) {
    hostUrl = urlParts.slice(1).join(".");
    return `https://${env.REACT_APP_API_SUBDOMAIN}.${hostUrl}/${
      addApi ? "api/" : ""
    }`;
  }
  return `https://${hostUrl}/${addApi ? "api/" : ""}`;
};

export const getExternalLoginUrl = () => {
  return `${getApiBaseUrl()}${apiPaths.providerChallenge}`;
};

export const getMySessionsUrl = () => {
  return toExternalHref(`/${t("route.mySessions")}`);
};

export const getSessionBookingUrl = (sessionType) => {
  return `${t("route.booking")}/${t("route.introductory")}?${t(
    "route.booking.sessionType",
  )}=${sessionType}`;
};
